import { get, post } from '@/utils/request'

// 获取安装包详情
export function getPackageInfo(type) {
  return get(`/package/type/${type}`)
}

// 上传安装包
export function uploadPackage(data) {
  return post('/package/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 下载安装包
export function downloadPackage(type) {
  return get(
    `/package/download/${type}`,
    {},
    {
      responseType: 'blob'
    }
  )
}

// 获取包类型列表
export function getPackageTypes() {
  return get('/package/types')
}

// 获取发版记录列表
export function getPackageList(params) {
  return get('/package/list', params)
}
